/** How a lesson video's length and dates read, wherever a video is listed. */

/** "0:24" */
export function length(seconds: number | null): string {
  if (seconds === null) return '';
  const whole = Math.round(seconds);
  return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, '0')}`;
}

export function day(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
}

export function dayAndTime(iso: string): string {
  return `${day(iso)}, ${new Date(iso).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`;
}
